import {performHttpRequest} from "../http";

export async function getWmsInfo(category, data) {

    return performHttpRequest(
        window.kaartViewerUrl + '/admin/v2/kaartviewerapi/bookmark/' + window.websiteID + '/bookmarkpresentation/' + category + '/info',
        'POST',
        data
    )
}

export async function getWmsExtent(category) {

    return performHttpRequest(
        window.kaartViewerUrl + '/admin/v2/kaartviewerapi/bookmark/' + window.websiteID + '/bookmarkpresentation/' + category + '/extent',
        'GET',
    )
}
